export default __webpack_public_path__ + "static/media/mobileBanner.1eeff529.webp";